import { NavigationGuardNext, Route } from 'vue-router'

import { isLogin, toLogin } from '@utils/index'
import Common from '../common.vue'
export default {
  path: '/user',
  component: Common,
  beforeEnter: (to: Route, from: Route, next: NavigationGuardNext) => {
    if (isLogin()) {
      next()
    } else {
      toLogin()
    }
  },
  children: [
    {
       /**我的佣金 */
      name: 'commission',
      path: 'commission',
      component: () => import('./commission/commission.vue')
    }
  ]
}
